import React from 'react'
import { Box, IconButton, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import UserImg from '../assests/sampleuser.svg'
import ReyLeaf from '../../common/assests/reyleafLogo.svg'
import EyeIcon from "../../common/assests/eyeicon.png";
import configuration from '../../config/Config';

const OrderManagementRow = ({rows,handleModal}) => {
  return (
      <TableRow
        key={rows?._id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell sx={{whiteSpace: "nowrap"}}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
                 <img
                     src={
                      rows?.user?.picture
                        ? `${configuration.cdnFront}/${ rows?.user?.picture}`
                        : UserImg
                }
              style={{
                height: "35px",
                width: "35px",
                marginRight: "8px",
                borderRadius: "50%",
              }}
            />
            <Typography >{rows?.user?.fullname||"-"}</Typography>
          </Box>
        </TableCell>
        <TableCell sx={{whiteSpace: "nowrap"}}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
                     src={
                      rows?.seller?.picture
                        ? `${configuration.cdnFront}/${ rows?.seller?.picture}`
                        : ReyLeaf
                }
              style={{
                height: "35px",
                width: "35px",
                marginRight: "8px",
                borderRadius: "50%",
              }}
            />
            <Typography>{rows?.seller?.fullname||"-"}</Typography>
          </Box>
        </TableCell>
        <TableCell sx={{whiteSpace: "nowrap"}}>
            {rows?.address
            ? [
                rows.address.address || "",
                // order.address.city || "",
                // order.address.state || "",
                // order.address.country || "",
                // order.address.zipcode || ""
                ]
                .filter(Boolean)
                .join(", ")
            : "-"}
        </TableCell>
        <TableCell>{`$${rows?.totalAmount ? rows?.totalAmount:"-"}`}</TableCell>
        <TableCell>
            {rows?.items?.reduce(
            (total, item) => total + (item?.quantity || 0),
            0
            )}
        </TableCell>
        <TableCell>{rows?.paymentStatus||"-"}</TableCell>
        <TableCell>{rows?.status||"-"}</TableCell>
        <TableCell>
          <IconButton  onClick={handleModal}>
         
            <img
              src={EyeIcon}
              alt="viewicon"
              style={{
                height:"45px",
                width:"45px",
              }}
            />
          </IconButton>
        </TableCell>
      </TableRow>
  )
}

export default OrderManagementRow